import { createFileRoute } from '@tanstack/react-router'
import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('manset-brilles')!
export const Route = createFileRoute('/manset-brilles')({ loader: () => loadBrandCampaign(campaign), head: () => brandCampaignHead(campaign), component: Page })
function Page() { return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} /> }
